module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[22]509.d42d364.woff2";